import { DateTime } from 'luxon';
import type React from 'react';

import DateField from 'components/Transactions/DateField';
import SPayeeField from 'components/SPayeeField';

import { useStyles } from '../styles';

type Props = {
  date: DateTime;
  dateError?: string;
  dateInfoText: string | null;
  disabled: boolean;
  focusSplits?: boolean;
  futureTxnsFf: boolean;
  payee: string;
  setDate: (date: DateTime) => void;
  setDateError: (error: string | undefined) => void;
  setPayee: (payee: string) => void;
};

export default function PayeeDateRow({
  date,
  dateError,
  dateInfoText,
  disabled,
  focusSplits,
  futureTxnsFf,
  payee,
  setDate,
  setDateError,
  setPayee,
}: Props): React.JSX.Element {
  const { classes } = useStyles();

  return (
    <div id='payee-date-row' className={classes.thinRow}>
      <SPayeeField
        id='payee-field-editable'
        defaultValue={payee}
        onChange={setPayee}
        className={classes.payeeField}
        popupIcon={null}
        autoFocus={!focusSplits}
      />
      <DateField
        date={date}
        onChange={setDate}
        onError={(error: string | undefined) => {
          setDateError(error);
        }}
        maxDate={futureTxnsFf ? DateTime.now().plus({ year: 1 }) : undefined}
        className={classes.dateField}
        variant='filled'
        allowInvalid
        error={!!dateError}
        helperText={dateError || dateInfoText || ''}
        disabled={disabled}
      />
    </div>
  );
}
